import { render, staticRenderFns } from "./GoodbyeMessage.vue?vue&type=template&id=30064944&"
import script from "./GoodbyeMessage.vue?vue&type=script&lang=js&"
export * from "./GoodbyeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports